import { useReducer } from 'react';
import axiosClient from 'api/axiosClient';
import useToaster from 'hooks/store/toast/useToaster';
import useAddAdminUsers from 'hooks/store/add-admin-users/useAddAdminUsers';

interface useGetRegionsState {
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  data: any;
  error: any;
}

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  data: null,
  error: null,
};

const reducer = (state: useGetRegionsState, payload: Partial<useGetRegionsState>) => ({ ...state, ...payload });

type FetchOptions = { silent?: boolean };

export default function useGetAdminUser() {
  const [state, setState] = useReducer(reducer, initialState);
  const { setState: setUpdate } = useAddAdminUsers();
  const showToast = useToaster(state => state.showToast);

  const getAdminUser = async (userId: string, options?: FetchOptions) => {
    setState({ isLoading: true });
    try {
      const data = await axiosClient.get(`/admin/getAdminUser?userId=${userId}`).then(res => res.data);
      setState({ isSuccess: true, data });
      setUpdate({ adminUser: data });
    } catch (error: any) {
      setState({ isError: true, error });
      const status = error?.response?.status;
      if (status !== 401 && !options?.silent) {
        showToast('Danger', error?.response?.data?.msg || 'Failed to fetch admin user');
      }
    } finally {
      setState({ isLoading: false });
    }
  };

  const resetResponse = () => setState({ ...initialState });

  return {
    ...state,
    getAdminUser,
    resetResponse,
  };
}
